function addClone(parent) {
  const clone = document.querySelector('.data-clone')
  const area = parent.querySelector('.item-poll-questions__list')

  if (area.dataset.count) {
    area.dataset.count = +area.dataset.count + 1
  } else {
    area.dataset.count = 2
  }

  area.insertAdjacentElement('beforeend', clone.cloneNode(true))

  cleanClone(area.lastChild, area)
}

function cleanClone(child, area) {
  child.removeAttribute('style')
  child.classList.remove('data-clone')
  child.querySelectorAll('.rating-stars').forEach(e => {
    const rand = Math.ceil(Math.random() * 1e12)
    e.querySelectorAll('[name]').forEach(e => {
      e.name = rand
    })
  })
  child.querySelector(
    '.rating__title',
  ).innerHTML = ` Поставщик №${area.dataset.count}`
}

function dataAttribute(data, nameAttribute) {
  const area = data.closest('[data-count]')
  const parent = data.closest('.rating')
  parent.dataset[nameAttribute] = data.value
  parent.dataset.dealer_id = area.dataset.count

}

function ratingData(parent, nameAttribute) {
  const ratingItem = parent.querySelectorAll('.rating__item')
  const main = parent.closest('.rating')

  const name = []

  ratingItem.forEach(e => {
    const allInp = e.querySelectorAll('.rating-stars > label > input')
    let rate

    allInp.forEach(e => {
      if (e.checked) {
        rate = e.value
      }
    })
    name.push({
      name: e.querySelector('.rating__item-text').textContent,
      count: +rate || 0,
    })
  })

  main.dataset[nameAttribute] = JSON.stringify(name)
}

function collectionsData() {
  const sections = document.querySelectorAll('.poll__questions-list > li')
  const data = []

  sections.forEach((section, s_id) => {
    data.push({ name: section.dataset.type, dealers: [] })
    section.querySelectorAll('.rating').forEach(item => {
      data[s_id].dealers.push({
        dealer_id: item.dataset.dealer_id,
        dealer_name: item.dataset.dealer_name,
        desc: item.dataset.description,
        rating: item.dataset.rating ? JSON.parse(item.dataset.rating) : [],
      })
    })
  })

  return JSON.stringify(data)
}

function pollSendForm(url) {
  const resp = fetch(url, {
    method: 'POST',
    body: collectionsData(),
  }).then(res => res.json())
  resp.then(data => {
    if (data.status === 'success') {
      // $.fancybox.open({
      //   src: '#popup-dealer-success',
      //   toolbar: false,
      // });
      $.fancybox.open({
        src: '#popup-fortuna-form-dealer',
        toolbar: false,
      });
    } else {
      $.fancybox.open({
        src: '#popup-dealer-error',
        toolbar: false,
      });
    }
  })
}
